<template>
  <div>
    <groups-list
      :items="elements"
      :loading="loading"
      :count="count"
      :search="search"
      mode="loadMore"
      :show-load-more="true"
      @tabChanged="onTabChange"
      @cellClicked="onCellClicked"
      @createGroup="onOpenCreateGroup"
      @onSearch="onSearch"
      @reload="reload"
      @delete="onDelete"
      @pageChange="onPageChange"
      @load-more="loadMore"
    />

    <group-create
      ref="create"
      :show-create="showCreate"
      @create="onCreateGroup"
      @close="onClose"
    />
  </div>
</template>
<script>

import { EventBus } from '@/event-bus';

import _ from 'lodash';
import GroupsList from './GroupsList';
import GroupCreate from './GroupsList/GroupCreate';
import Listable from '../mixins/listable';

export default {
  name: 'GroupsListContainer',
  components: {
    GroupsList,
    GroupCreate,
  },
  mixins: [Listable],
  props: {
    source: {
      type: String,
      default: 'groups',
    },
    getter: {
      type: String,
      default: 'groups',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    customFetchRoute: {
      type: String,
      default: 'fetchStylistGroups',
    },
    requiresId: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showCreate: false,
    };
  },
  computed: {
    permissionViewsAllClient() {
      return this.usePermission('view_all_clients') || this.useFeature('edits_sendable_to_all_institution_clients');
    },
    count() {
      return this.$store.state.groups.count;
    },
    profile() {
      if (!this.$store.state.account.user.profile) {
        return {
          pk: null,
        };
      }
      return this.$store.state.account.user.profile;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    onTabChange(evt) {
      if (this.permissionViewsAllClient) {
        if (evt === 1) {
          this.$router.push('/clients/all');
        } else if (evt === 2) {
          this.$router.push('/clients/groups');
        } else {
          // TODO for My Clients
          this.$router.push('/clients/my');
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (evt === 0) {
          this.$router.push('/clients/my');
        } else {
          this.$router.push('/clients/groups');
        }
      }
    },
    onCellClicked(evt) {
      this.$router.push(`/clients/groups/${evt.pk}`);
    },
    onOpenCreateGroup() {
      this.$refs.create.open();
      this.showCreate = true;
    },
    onCreateGroup(evt) {
      this.$store.dispatch('customers/addGroup', evt)
        .then((response) => {
          const { pk } = response.data;
          this.showCreate = false;
          this.$nextTick().then(() => {
            this.$router.push(`/clients/groups/${pk}`);
          });
        }).catch((e) => {
          this.showCreate = false;
          this.$nextTick().then(() => {
            EventBus.$emit('toast-error', 'A group with the same name already exists.');
          });
        });
    },
    onClose() {
      this.showCreate = false;
    },
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    onDelete(group) {
      this.$store.dispatch('groups/deleteGroup', group.pk);
    },
    onPageChange(page) {
      this.truePage = page;
      window.scroll({ top: 0, left: 0 });
    },
    fetchData() {
      if (this.loading) {
        console.debug('already loading');
        return;
      }
      this.requestFailed = false;

      const kwargs = {
        ...this.queryParams,
        page: this.truePage,
        search: this.search,
        page_size: this.pageSize,
      };
      const id = this.profile.pk;
      this.$store.dispatch(`${this.source}/fetchStylistGroups`, { id, kwargs }).then((response) => {
        if (response && response.data) {
          this.nextPageExists = response.data.next != null;
        }
      }).catch((response) => {
        if (response.response == null) {
          // Network error
          this.requestFailed = true;
        } else if (response.response.status === 404) {
          // Page doesn't exist
        } else {
          // Server errro
          this.requestFailed = true;
        }
        this.$store.commit(`${this.source}/setIsLoading`, false);
      }).finally(() => {});
    },
  },
};
</script>
